import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Row } from "reactstrap";
import { IContentTitles } from "../app/models/content";
import { RootStoreContext } from "../app/stores/rootStore";
import GenericBrowsePageResizeHelper from "../components/common/GenericBrowsePageResizeHelper";
import Loader from "../components/common/Loader";
import GenericTeletabberGallery from "../components/gallery/GenericTeletabberGallery";
import TitleNavbar from "../components/navbars/TitleNavbar";
import ToolbarSelector from "../components/navbars/ToolbarSelector";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../app/localization/localization";

interface IParams {
  boardId: string;
  nodeId: string;
}

const BoardBrowsePage: React.FC<RouteComponentProps<IParams>> = ({
  match,
  location,
  history,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { loadBoardContent } = rootStore.boardStore;
  const [t] = useTranslation(["features"], translationHookOptions); 
  const { currentBrowsePageContent, selectedLanguageId, resetBrowsePage } =
    rootStore.commonStore;
  const { attendingMeeting } = rootStore.playerStore;
  const { errorUrl } = rootStore.tenantStore;
  const { setSourceId } = rootStore.meetingStore;
  const { resetSurveyParameters } = rootStore.surveyStore;
  const { destroyZwibblerContext } = rootStore.zwibblerStore;
  const [nodeId, setNodeId] = useState(0);
  const [boardId, setBoardId] = useState(0);
  const [galleryStartingPage, setGalleryStartingPage] = useState(0);

  useEffect(() => {
    let intNodeId = parseInt(match.params.nodeId);
    let intBoardId = parseInt(match.params.boardId);

    if (intNodeId && intBoardId) {
      setNodeId(intNodeId);
      setBoardId(intBoardId);
      if (attendingMeeting) setSourceId(attendingMeeting.id);

      const urlParams = new URLSearchParams(location.search);
      //gallery page
      const page = urlParams.get("pag") ?? "";
      let intPage = parseInt(page);
      setGalleryStartingPage(intPage);
      //board language
      const lang = urlParams.get("lang") ?? "";
      let documentLanguage = lang ? parseInt(lang) : selectedLanguageId;
      loadBoardContent(intNodeId, documentLanguage)
        .then()
        .catch(() => history.push(errorUrl));
    } else history.push(errorUrl);

    return () => {
      resetSurveyParameters();
      resetBrowsePage();
      destroyZwibblerContext();
    };
  }, [
    location.search,
    match.params.boardId,
    match.params.nodeId,
    errorUrl,
    history,
    setSourceId,
    attendingMeeting,
    loadBoardContent,
    selectedLanguageId,
    resetSurveyParameters,
    resetBrowsePage,
    destroyZwibblerContext,
  ]);

  // const getPageTitle = (contentTitle: IContentTitles) => {
  //   return `${contentTitle.document} (${contentTitle.source})`;
  // };
  const getPageTitle = (contentTitle: IContentTitles) => {
    return `${contentTitle.document} (${t("BOARD")})`;
  };
  if (!currentBrowsePageContent) return <Loader />;

  return (
    <>
      <GenericBrowsePageResizeHelper />
      <Row>
        <TitleNavbar title={getPageTitle(currentBrowsePageContent.title)} />
      </Row>
      <Row>
        <ToolbarSelector
          items={currentBrowsePageContent.items}
          isSidebarOpen={true}
          languageSelectionConfig={{
            changeLanguage: (l) => loadBoardContent(nodeId, l).then(res => res.contentData.convertedPagesNumber),
          }}
          contentConfig={{
            contentId: currentBrowsePageContent.contentId!,
            downloadConfig: {
              source: "boards",
              sourceId: boardId,
            },
            enableNotes: true,
          }}
          stickyButton="share"
        />
      </Row>
      <Row>
        <GenericTeletabberGallery
          items={currentBrowsePageContent.items}
          startingPage={galleryStartingPage}
        />
      </Row>
    </>
  );
};

export default observer(BoardBrowsePage);
